module.exports = __webpack_public_path__ + "img/2-3.3b601086.svg";